import { SignoutModal } from "components/modal/SignoutModal";
import { Text } from "components/text";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu";
import { useAuth } from "contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "@tanstack/react-router";
import { ProfilePicture } from "../user/ProfilePicture";

export const UtilityMenu = () => {
  const { t } = useTranslation(["general"]);
  const { session } = useAuth();
  const location = useLocation();

  if (!session) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <div data-testid="account-menu" className="px-2">
          <ProfilePicture
            name={session.user.firstName ?? session.user.email ?? undefined}
            photoUrl={session.user.photoUrl}
          />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-56"
        side="bottom"
        align="end"
        sideOffset={30}
      >
        <DropdownMenuItem asChild>
          <Link
            to="/profile"
            state={{
              prevPath: location.pathname,
              prevSearch: location.searchStr,
            }}
          >
            <Text variant="detail">{t("general:header.profile")}</Text>
          </Link>
        </DropdownMenuItem>

        <DropdownMenuItem asChild>
          <Link to="/contact-us" target="_blank">
            <Text variant="detail">{t("components:header.contactUs")}</Text>
          </Link>
        </DropdownMenuItem>

        <DropdownMenuItem asChild>
          <a
            href="https://reedy.zendesk.com/hc/en-gb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Text variant="detail">{t("general:header.helpCenter")}</Text>
          </a>
        </DropdownMenuItem>

        {session.user.isSuperAdmin && (
          <DropdownMenuItem asChild>
            <Link to="/settings">
              <Text variant="detail">{t("general:header.settings")}</Text>
            </Link>
          </DropdownMenuItem>
        )}

        <DropdownMenuItem asChild>
          <SignoutModal />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
